<template>
  <div>
    <div v-if="!loading">
      <b-card no-body class="bdr-tabs">
        <b-tabs 
          v-model="tabIndex"
          card 
          style="flex-direction: column;"
        >
          <typ-dog
            :docHistory.sync="docHistory"
            active
          />

          <typ-dog-teo-exp
            :docHistory.sync="docHistory"
          />
        </b-tabs>

        <div class="d-flex justify-content-between my-2">
          <div class="text-left ml-4">
            <b-button
              v-if="tabIndex==1"
              @click="copyFromTD()"
            >
              Скопировать из ТД
            </b-button>
          </div>
          <div class="text-right mr-4">
            <b-button
              @click="saveDoc"
            >
              Сохранить
              <i class="fas fa-spinner fa-spin ml-2" v-if="saving"></i>
            </b-button>
            <b-button
              variant="success"
              class="ml-2"
              @click="generateDoc"
            >
              Сгенерировать договор
              <i class="fas fa-spinner fa-spin ml-2" v-if="generating"></i>
            </b-button>
            <b-button
              variant="primary" 
              class="ml-2"
              :href="downloadLink.link"
              target="_blank"
              @click="clearDownloadLink()"
              v-if="!saving && !generating && downloadLink.link"
            >
              Скачать договор
              <i class="fas fa-download ml-2"></i>
            </b-button>
          </div>
        </div>
      </b-card>
    </div>
    <div v-else>
      <b-overlay
        :show="true"
        no-wrap
      >
        <template #overlay>
          <div class="text-center text-success my-5">
            <b-spinner variant="success"></b-spinner>
          </div>
          <div class="text-center">Ожидайте...</div>
        </template>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import TypDog from '@components/companies/contracts/TypDog';
import TypDogTeoExp from '@components/companies/contracts/TypDogTeoExp';
import { API_COMPANY, API_COMPANY_DOC_GENERATOR, API_POST_WORD_DOC_BY_TEMPLATE, API_DADATA_NAME } from '@/constants';
import { typ_dog, typ_dog_teo_exp } from '@/constants/docHistory';

const initialDocHistory = () => (
    {
      'typ_dog': structuredClone(typ_dog),
      'typ_dog_teo_exp': structuredClone(typ_dog_teo_exp),
    }
);

export default {
  components: {
    TypDog,
    TypDogTeoExp,
  },
  props: {
    companyId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      detailedItem: {},
      docHistory: {
        'typ_dog': structuredClone(typ_dog),
        'typ_dog_teo_exp': structuredClone(typ_dog_teo_exp),
      },
      saving: false,
      loading: true,
      generating: false,
      tabIndex: 0,
      downloadLink: {},
    };
  },
  mounted() {
    this.loadOneItem()
  },
  methods: {
    loadOneItem() {
      this.loading = true;

      api.call('get', `${API_COMPANY}/${this.companyId}`).then(({data}) => {
        this.detailedItem = data;
        this.loading = false;
        this.loadHistoryItem();
      })
    },
    loadHistoryItem() {
      this.loading = true;

      api.call('get', `${API_COMPANY_DOC_GENERATOR}/${this.companyId}`).then(({data}) => {
        if (!data.data) {
          this.docHistory = initialDocHistory();
          this.addCalculatedParameters();
        } else {
          this.docHistory['typ_dog'] = Object.assign(typ_dog, data.data['typ_dog']);
          this.docHistory['typ_dog_teo_exp'] = Object.assign(typ_dog, data.data['typ_dog_teo_exp']);

          this.docHistory['typ_dog'].full_org_name_not_caps = this.capitalizeFirstLetters(this.cleanString(this.detailedItem.name));
          this.docHistory['typ_dog_teo_exp'].full_org_name_not_caps = this.capitalizeFirstLetters(this.cleanString(this.detailedItem.name));
        }

        this.docHistory['companyDetails'] = this.detailedItem;

        this.loading = false;
      })
    },
    loadNameDeclination(name) {
      this.loading = true;

      return api.call('post', `${API_DADATA_NAME}`, {name: name});
    },
    addCalculatedParameters() {
      for (let key in this.docHistory) {
        if (this.detailedItem.name.includes('ООО')) {
          this.docHistory[key].full_pravovaya_form = 'Общество с ограниченной ответственностью';
          this.docHistory[key].short_pravovaya_form = 'ООО';
        } else if (this.detailedItem.name.includes('АО')) {
          this.docHistory[key].full_pravovaya_form = 'Акционерное общество';
          this.docHistory[key].short_pravovaya_form = 'АО';
        } else if (this.detailedItem.name.includes('ИП')) {
          this.docHistory[key].full_pravovaya_form = 'Индивидуальный предприниматель';
          this.docHistory[key].short_pravovaya_form = 'ИП';
        } else {
          this.docHistory[key].full_pravovaya_form = 'Общество с ограниченной ответственностью';
          this.docHistory[key].short_pravovaya_form = 'ООО';
        }

        this.docHistory[key].full_org_name = this.cleanString(this.detailedItem.name);

        this.docHistory[key].full_org_name_not_caps = this.capitalizeFirstLetters(this.cleanString(this.detailedItem.name));


        this.docHistory[key].in_face_of_org = this.detailedItem.type_director ? this.capitalizeFirstLetter(this.detailedItem.type_director) : 'Генерального директора';
        if (this.docHistory[key].in_face_of_org == 'Генеральный директор') {
          this.docHistory[key].in_face_of_org = 'Генерального директора';
        }

        let tempName = this.detailedItem.director ?? 'ИМЯ';
        this.docHistory[key].fio_of_face_of_org = tempName;

        this.loadNameDeclination(tempName)
          .then(({data}) => {
            if (data[0]) {
              tempName = data[0].result_genitive;
            }

            this.docHistory[key].fio_of_face_of_org = tempName;
            this.loading = false;
          })
          .catch(() => this.loading = false);


        this.docHistory[key].ogrn_of_org = this.detailedItem.ogrn;
        this.docHistory[key].kpp_of_org = this.detailedItem.kpp;
        this.docHistory[key].inn_of_org = this.detailedItem.inn;
        this.docHistory[key].ur_adress = this.detailedItem.address;
        this.docHistory[key].tel_of_org = this.detailedItem.phones;
        this.docHistory[key].in_face_imen_padej_of_org = this.capitalizeFirstLetter(this.detailedItem.type_director);
        this.docHistory[key].fio_of_face_short_of_org = this.nameToShortForm(this.detailedItem.director);
      }
    },
    cleanString(input) {
      const unwantedElements = ['\'', '"', '', '/', '«', '»', 'ООО', 'АО', 'ИП', 'ОАО'];

      const pattern = new RegExp(unwantedElements.map(element => `\\${element}`).join('|'), 'g');

      return input.replace(pattern, '').trim();
    },
    saveDoc() {
      this.saving = true;

      if (this.docHistory.id) {
        api.call('put', `${API_COMPANY_DOC_GENERATOR}/${this.companyId}`, { data: this.docHistory }).then(({data}) => {
          this.docHistory = data.data;
          this.saving = false;
        })
      } else {
        api.call('post', `${API_COMPANY_DOC_GENERATOR}`, { data: this.docHistory, company_id: this.companyId }).then(({data}) => {
          this.docHistory = data.data;
          this.saving = false;
        })
      }
    },
    generateDoc() {
      this.generating = true;
      if (this.tabIndex === 0) {
        api.call('post', `${API_POST_WORD_DOC_BY_TEMPLATE}`, { data: this.docHistory['typ_dog'], templateName: 'typ_dog', company_id: this.companyId })
           .then(({data}) => {
            this.generating = false;
            this.downloadLink = data;
          })
      } else if (this.tabIndex === 1) {
        api.call('post', `${API_POST_WORD_DOC_BY_TEMPLATE}`, { data: this.docHistory['typ_dog_teo_exp'], templateName: 'typ_dog_teo_exp', company_id: this.companyId })
           .then(({data}) => {
            this.generating = false;
            this.downloadLink = data;
          })
      }
    },
    createdDoc() {
      // когда получен док
      this.generating = false;
    },
    clearDownloadLink() {
      setTimeout(() => {
        this.downloadLink.link = '';
      }, 300);
    },
    capitalizeFirstLetter(word) {
      if (word) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }

      return word;
    },
    capitalizeFirstLetters(string) {
      const result = string.replace(/([а-яА-ЯЁё])([а-яА-ЯЁё]*)/gi, (_, p1, p2) => 
        p1.toUpperCase() + p2.toLowerCase()
      )
      return result
    },
    nameToShortForm(name) {
      if (name) {
        let newName = name.split(' ');
        return newName.length > 2 ? (newName[1][0] + '.' + newName[2][0] + '.' + this.capitalizeFirstLetter(newName[0])) : name
      }
    },
    copyFromTD() {
      for (let index in this.docHistory['typ_dog_teo_exp']) {
        if (this.docHistory['typ_dog'][index]) {
          this.docHistory['typ_dog_teo_exp'][index] = this.docHistory['typ_dog'][index];
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
  .bdr-tabs .card-body {
    padding: 1.25rem 0px;
  }
</style>
